import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, Observable, of } from 'rxjs';
import { NotificationItemsResponseDto } from 'src/app/shared/dtos/notification-item.dto';
import { transformAndValidatePipe } from 'src/app/shared/utils/operators';
import { datadogLogs } from '@datadog/browser-logs';

@Injectable({
  providedIn: 'root'
})
export class NotificationsService {
  isOpen = false;
  http = inject(HttpClient);

  toggleNotifications(): void {
    this.isOpen = !this.isOpen;
  }

  closeNotifications(): void {
    this.isOpen = false;
  }

  getNotifications(): Observable<NotificationItemsResponseDto | null> {
    const date = new Date();
    date.setDate(date.getDate() - 30);
    const formattedTime = Math.round(date.getTime() / 1000);

    return this.http.get<NotificationItemsResponseDto>(`/api/messages/retrieve/${formattedTime}`).pipe(
      transformAndValidatePipe(NotificationItemsResponseDto),
      catchError((err: Error) => {
        datadogLogs.logger.error('Notification retrieval failed', {}, err);
        return of(null);
      })
    )
  }

  markAsRead(ids: number[]): Observable<void> {
    return this.http.post<void>('/api/messages/mark/read', { ids }).pipe(
      catchError((err: Error) => {
        datadogLogs.logger.error('Notification mark as read failed', {}, err);
        return of(undefined);
      })
    );
  }
}
